import React from 'react';

function AppointedSupplierField({ data, value, maxLength }) {
  if (data.intern == false) return <>Altro (fornitore esterno)</>;

  return <>{value}</>;
}

export default AppointedSupplierField;
